import { update } from './update';

export function request(oddsFormat) {
    return {
        type: 'USER_CHANGE_ODDS_REQUEST',
        oddsFormat
    };
}

export function error(errors) {
    return {
        type: 'USER_CHANGE_ODDS_ERROR',
        errors
    };
}

export function finish(user) {
    return (dispatch) => {
        dispatch(update(user));

        dispatch({
            type: 'USER_CHANGE_ODDS_FINISH'
        });
    };
}

export function clear() {
    return {
        type: 'USER_CHANGE_ODDS_CLEAR'
    };
}
